import { EM } from "msd-capacity-planning-model";
import {
  EMAction,
  EMsState,
  FETCH_EMS,
  LOAD_EMS,
  PERSIST_EM,
  REMOVE_EM,
  SET_EMS_DATE_FILTER
} from "./EMsTypes";
import { dateFilterStorage } from "../utils/dateFilterStorage";

const initialState: EMsState = {
  items: {},
  synching: true,
  dateFilter: dateFilterStorage.get() || undefined,
};

export default function emsReducer(
  state = initialState,
  action: EMAction
): EMsState {
  switch (action.type) {
    case FETCH_EMS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_EM:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_EM:
      return {
        ...state,
        synching: true,
      };
    case LOAD_EMS: {
      const dateFilter = action.dateFilter || state.dateFilter;
      const filterDate = dateFilter ? new Date(dateFilter) : (() => {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return oneYearAgo;
      })();

      return {
        ...state,
        items: action.items.reduce((all: { [id: string]: EM }, item) => {
          if(!item.offboardDate || (
            item.offboardDate &&
            new Date(item.offboardDate.year, item.offboardDate.month, item.offboardDate.day) >= filterDate
          ))
          {
            all[item.id] = item;
          }

          return all;
        }, {}),
        synching: false,
        dateFilter,
      };
    }
    case SET_EMS_DATE_FILTER: {
      // Save to localStorage
      dateFilterStorage.set(action.dateFilter);
      return {
        ...state,
        dateFilter: action.dateFilter,
      };
    }
    default:
      return state;
  }
}
